import React from 'react';
import { TFunction } from 'i18next';
import _get from 'lodash/get';
import { Site } from 'graphql-common';
import TextCell from '@lib/components/Table/commonComponents/TextCell/TextCell';
import ChipCell from '@lib/components/Table/commonComponents/ChipCell/ChipCell';
import { CellProps, Column } from '@lib/components/Table/types';
import { ChipTypes } from '@lib/components/Chip/Chip';

type ColumnsArgs = {
  onViewHandler: (v: Site) => void;
  t: TFunction<'translation', undefined>;
};

export default function getSitesTableColumns({
  onViewHandler,
  t,
}: ColumnsArgs) {
  const result: Column<Site>[] = [
    {
      id: 'code',
      Header: t('code'),
      accessor: 'code',
      Cell: (props: CellProps<Site>) => <TextCell {...props} />,
      minWidth: 110,
      maxWidth: 110,
      width: 110,
    },
    {
      id: 'name',
      Header: t('name'),
      accessor: 'name',
      Cell: ({ item }: CellProps<Site>) => {
        const label = _get(item, 'name', '');
        if (!label) return '-';
        return (
          <ChipCell
            label={label}
            type={ChipTypes.chipGray}
            onClick={() => onViewHandler(item)}
          />
        );
      },
      maxWidth: 250,
      minWidth: 250,
      sortable: true,
    },
    {
      id: 'sectorName',
      Header: t('sector'),
      accessor: 'sector',
      Cell: (props: CellProps<Site>) => {
        const label = _get(props, 'item.sector.name', '');
        const color = _get(props, 'item.sector.color', '') as ChipTypes;
        if (!label) return '-';
        return (
          <ChipCell
            leftIcon="circle"
            label={label}
            type={color || ChipTypes.chipGray}
          />
        );
      },
      sortable: true,
      width: 200,
      maxWidth: 200,
      minWidth: 200,
    },
    {
      id: 'siteAreasCount',
      Header: t('areas'),
      accessor: 'siteAreasCount',
      Cell: (props: CellProps<Site>) => <TextCell {...props} />,
      minWidth: 150,
      maxWidth: 150,
      width: 150,
      sortable: true,
    },
    {
      id: 'usersCount',
      Header: t('members'),
      accessor: 'usersCount',
      Cell: (props: CellProps<Site>) => <TextCell {...props} />,
      minWidth: 150,
      maxWidth: 150,
      width: 150,
      sortable: true,
    },
  ];
  return result;
}
